// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F7Xn","left":"styles_left__1HQpW","desktopActions":"styles_desktopActions__13726","title":"styles_title__3Zing"};